import { type LeadBannerPayload } from '@travelata-libs/ui-shared';
import { useTravelataApiService, useTravelataAppConfig } from '@/shared/composables';
import { useSentryService } from '@/shared/di';
import { type BaseResponse } from '@/shared/model';

export const createLead = async (data: LeadBannerPayload) => {
  const sentryService = useSentryService();
  const apiService = useTravelataApiService();
  const appConfig = useTravelataAppConfig();
  try {
    const response = await apiService.post<BaseResponse, LeadBannerPayload>(
      `${appConfig.apiGatewayUrl}/frontend/leads`,
      data,
      {
        headers: {
          'Content-type': 'application/json; charset=utf-8',
        },
      },
    );
    if (!response.success) {
      throw new Error('api-gateway/frontend/leads success false');
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Неизвестная ошибка';
    sentryService.captureException(`Ошибка создания лида api-gateway/frontend/leads: ${message}`);
    throw new Error(message);
  }
};
